import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { getFunnelPaths } from "routes/adFunnel";

export default function PaymentFailPromotion() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  useEffect(() => {
    // 실패 정보 로깅 (필요시)
    const code = searchParams.get("code");
    const message = searchParams.get("message");

    if (
      code === "PAY_PROCESS_CANCELED" ||
      message === "사용자가 결제를 취소하였습니다"
    ) {
      // ignore
    } else {
      if (message) {
        alert(message);
      }
    }

    // navigate(replace) 만 쓰면 fail 항목만 교체되고 그 직전의 Toss 도메인 항목이
    // 그대로 남아, 결제 페이지에서 swipe back 시 만료된 Toss 화면으로 이동한다.
    // 결제 시작 직전 저장한 history.length 와의 차이를 delta 로 두어 Toss 가 push 한
    // 항목 수(3DS·ISP 인증으로 가변적)에 무관하게 정확히 직전 결제 페이지 항목으로 복귀.
    let stored: string | null = null;
    try {
      stored = sessionStorage.getItem("promotionPaymentStartHistoryLength");
      sessionStorage.removeItem("promotionPaymentStartHistoryLength");
    } catch {}

    const startLen = stored != null ? parseInt(stored, 10) : NaN;
    const delta = window.history.length - startLen;

    if (Number.isFinite(startLen) && delta >= 1 && delta <= 15) {
      window.history.go(-delta);
    } else {
      navigate(`${getFunnelPaths().onboardingBase}/payment/1`, {
        replace: true,
      });
    }
  }, [searchParams, navigate]);

  return null;
}
